//#region Imports
/**
To use React related functionality
*/
import React from 'react';
/**
To use Icon.
*/
import { IconAlert } from '../../Icons';
//#endregion

//shows trip warnings
const TripWarning = props => {
    //icon stores icon html
    //stores value for Screen readers
    //summaryText stores summary text
    //isSummary stores value to decide show summary or not
    const {icon, screenReaderText, summaryText, isSummary} = props;
    if (isSummary) {
        return (
            <div className="otp-warning">
                {icon}
                {summaryText}
            </div>
        );
    }
    return (
        <span className="otp-trip-warning">
            {icon}
            <span className="screen-reader-text">{screenReaderText}</span>
        </span>
    );
};

//sets default props for component
TripWarning.defaultProps = {
    isSummary: false,
    icon: <IconAlert />,
    screenReaderText: 'warning',
    summaryText: 'Some of your trips have warnings'
};

export default TripWarning;